// @flow
import React, { useEffect } from 'react';
import type { MapConfig as MapConfigType } from '../../../types';
import Config from '../../../models/Config';
import SourceList from './SourceList';

export type Props = $ReadOnly<{
    mapConfig: MapConfigType,

    previewMapSource: (sourceId: string | null) => void
}>;
function MapConfig({ mapConfig, previewMapSource }: Props) {
    useEffect(() => {
        return () => {
            previewMapSource(null);
        };
    }, [previewMapSource]);

    const onSourcesChange = (sources: $PropertyType<MapConfigType, 'sources'>) => {
        const newExternalSources = sources.filter(source => !source.internal);

        Config.findByIdAndUpdate('map', { sources: newExternalSources }, { upsert: true });
    };

    const handleActivateSource = (sourceId: string) => {
        Config.findByIdAndUpdate('map', { activeSource: sourceId }, { upsert: true });
    };

    return (
        <SourceList
            sources={mapConfig.sources}
            activeId={mapConfig.activeSource}
            onChange={onSourcesChange}
            onPreview={previewMapSource}
            onActivate={handleActivateSource}
        />
    );
}

export default MapConfig;